import React, { useMemo, useRef, useState } from 'react';
import Login from './login';
import ForgotPassword from './forgotPassword';
import VerifyCode from './verifyCode';
import SetNewPassword from './setNewPassword';
import NewPasswordRequired from './newPasswordRequired';
import SetOrg from './setOrg';

const LoginForm = () => {
    const [ viewState, setViewState ] = useState('login');
    const [ confirmPasswordText, setConfirmPasswordText ] = useState('');
    const [ confirmPasswordUsername, setConfirmPasswordUsername ] = useState('');
    const [ newPasswordRequiredData, setNewPasswordRequiredData ] = useState(null);
    const [ verifiedCode, setVerifiedCode ] = useState('');
    const smsSentRef = useRef(false);
    const voiceCallSentRef = useRef(false);

    const login = useMemo(() => {
        return <Login
            setViewState={setViewState}
            setNewPasswordRequiredData={setNewPasswordRequiredData}
        />;
    }, []);

    const forgotPassword = useMemo(() => {
        return <ForgotPassword
            setConfirmPasswordText={setConfirmPasswordText}
            setConfirmPasswordUsername={setConfirmPasswordUsername}
            setViewState={setViewState}
        />;
    }, []);

    const verifyCode = useMemo(() => {
        return <VerifyCode
            confirmPasswordText={confirmPasswordText}
            confirmPasswordUsername={confirmPasswordUsername}
            setViewState={setViewState}
            setVerifiedCode={setVerifiedCode}
            setSmsSentToParent={v => { smsSentRef.current = v; }}
            setVoiceCallSentToParent={v => { voiceCallSentRef.current = v; }}
        />;
    }, [confirmPasswordText, confirmPasswordUsername]);

    const setNewPassword = useMemo(() => {
        return <SetNewPassword
            confirmPasswordUsername={confirmPasswordUsername}
            verifiedCode={verifiedCode}
            smsSentRef={smsSentRef}
            voiceCallSentRef={voiceCallSentRef}
            setViewState={setViewState}
            setNewPasswordRequiredData={setNewPasswordRequiredData}
        />;
    }, [confirmPasswordUsername, verifiedCode]);

    const newPasswordRequired = useMemo(() => {
        return <NewPasswordRequired
            newPasswordRequiredData={newPasswordRequiredData}
        />;
    }, [newPasswordRequiredData]);

    const setOrg = useMemo(() => {
        return <SetOrg />;
    }, []);

    switch (viewState) {
        case 'verify_code':
            return verifyCode;
        case 'set_new_password':
            return setNewPassword;
        case 'forgot_password':
        case 'reset_password':
            return forgotPassword;
        case 'new_password_required':
            return newPasswordRequired;
        case 'set_org':
            return setOrg;
        default:
            return login;
    }
};

export default LoginForm;
